// AUTO-GENERATED by scripts/build-glofox-portal-docs.mjs — do not edit by hand.

export interface GlofoxSearchEntry {
  route: string;
  title: string;
  section?: string;
  anchor?: string;
  text: string;
}

export const GLOFOX_SEARCH_INDEX: GlofoxSearchEntry[] = [
  {
    "route": "/glofox/error-handling",
    "title": "Error handling",
    "text": "Following REST standards, the API may return different HTTP error codes depending on the endpoint and the server’s logic."
  },
  {
    "route": "/glofox/error-handling",
    "title": "Error handling",
    "section": "Common error codes",
    "anchor": "common-error-codes",
    "text": "Status Code Description 400 Bad Request Indicates an issue with the request data, typically caused by invalid input. 401 Unauthorized The request is not authenticated. 403 Forbidden The client does not have permission to access the requested resource. 404 Not Found The requested resource does not ex…"
  },
  {
    "route": "/glofox/error-handling",
    "title": "Error handling",
    "section": "Error structure",
    "anchor": "error-structure",
    "text": "The error response follows a JSON structure like this: { \"message\" : \"Invalid email format\" , \"message_code\" : \"INVALID_EMAIL\" } Where: message: Provides a human-readable explanation of the error. message_code: Provides a key for the error that you use on the client side."
  },
  {
    "route": "/glofox/authentication",
    "title": "Authentication",
    "text": "This section describes authentication and authorization for the Glofox API. All API requests must include the following headers: x-glofox-branch-id , x-api-key , and x-glofox-api-token ."
  },
  {
    "route": "/glofox/authentication",
    "title": "Authentication",
    "section": "Get started",
    "anchor": "get-started",
    "text": "First, you need API credentials. Follow Get started to create an account, log in, and submit Request access from the top navigation. You receive credentials that grant access to the development endpoints. The Glofox API provides dedicated development, testing, staging, and sandbox environments to su…"
  },
  {
    "route": "/glofox/authentication",
    "title": "Authentication",
    "section": "Security and rate limiting",
    "anchor": "security-and-rate-limiting",
    "text": "The API applies security validations and rate limits. The main measures are those listed below. Backend proxies: perform all API key and token operations through a secure backend service. This prevents direct client‑side access and protects sensitive credentials. Use API keys and tokens exclusively…"
  },
  {
    "route": "/glofox/webhooks",
    "title": "Webhooks",
    "text": "Glofox supports webhooks for real-time updates. Configure each webhook to send events to one or more target URLs."
  },
  {
    "route": "/glofox/webhooks",
    "title": "Webhooks",
    "section": "Delivery model",
    "anchor": "delivery-model",
    "text": "Glofox sends each webhook to the configured URL as an HTTP POST request with a JSON payload. Your endpoint should respond with HTTP 200 when the event is accepted."
  },
  {
    "route": "/glofox/webhooks",
    "title": "Webhooks",
    "section": "Timeouts and retries",
    "anchor": "timeouts-and-retries",
    "text": "Timeout: The receiving endpoint must complete processing and return a response within 5 seconds , measured from connection establishment through delivery of the response. If the endpoint does not return a successful response within that interval, Glofox treats the delivery as failed. Retries: When a…"
  },
  {
    "route": "/glofox/webhooks",
    "title": "Webhooks",
    "section": "Payload structure",
    "anchor": "payload-structure",
    "text": "Each webhook payload is a JSON object with common fields: Field Description Type Event type identifier (for example, MEMBER_CREATED ) Metadata Context such as trace_id , location_id , and payload version Timestamp ISO 8601 timestamp when the event occurred Payload Event-specific data Event-specific…"
  },
  {
    "route": "/glofox/webhooks",
    "title": "Webhooks",
    "section": "Signature validation",
    "anchor": "signature-validation",
    "text": "Each webhook includes a signature HTTP header for source validation. Glofox provides the secret key for webhooks with your API credentials. The signature is a hexadecimal string that uses hash-based message authentication code with the 256-bit Secure Hash Algorithm, computed as Signature = Hex( HMAC…"
  },
  {
    "route": "/glofox/webhooks",
    "title": "Webhooks",
    "section": "Webhook types",
    "anchor": "webhook-types",
    "text": "For event-specific behaviour, payload schemas, and available event types, see the API Reference—Webhooks ."
  },
  {
    "route": "/glofox/common-concepts",
    "title": "Common concepts",
    "text": "This guide provides a high‑level overview of the core entities used to integrate with Glofox’s CRM and Member Management System (MMS), with the Fitness Center Member as the central pivot. It outlines how Locations contextualize services, Plans define offerings, Memberships bind members to plans, and…"
  },
  {
    "route": "/glofox/flows/agreements",
    "title": "Waiver and T&C flows",
    "text": "The Waiver and Terms & Conditions (T&C) flows currently offer only partial support, as there is no publicly accessible endpoint available to directly initiate these flows. Agreement email links provide partial support. Glofox automatically generates and sends them when a user registers (for the Waiv…"
  },
  {
    "route": "/glofox/flows/agreements",
    "title": "Waiver and T&C flows",
    "section": "Send agreement emails ( POST )",
    "anchor": "send-agreement-emails-post",
    "text": "To resend the agreement emails, use the following sample request: Endpoint: /2.2/branches/{branch_id}/users/{user_id}/agreements/{agreements_id}/send Method: POST Content-Type: application/json Required Headers { \"x-glofox-branch-id\" : \"{branch_id}\" , \"x-api-key\" : \"{api_key}\" , \"x-glofox-api-token\"…"
  },
  {
    "route": "/glofox/flows/agreements",
    "title": "Waiver and T&C flows",
    "section": "Get agreements ID ( GET )",
    "anchor": "get-agreements-id-get",
    "text": "To retrieve the agreements_id for a specific user, use the following endpoint: Endpoint: /2.2/branches/{{x-glofox-branch-id}}/users/{{sample-user-id}}/agreements Method: GET Content-Type: application/json Required Headers { \"x-glofox-branch-id\" : \"{branch_id}\" , \"x-api-key\" : \"{api_key}\" , \"x-glofox…"
  },
  {
    "route": "/glofox/flows/avatar",
    "title": "Avatar",
    "text": "Retrieving or managing a trainer’s profile avatar within the Glofox platform involves two main operations: fetching the current avatar and uploading a new one. The sections below outline both processes."
  },
  {
    "route": "/glofox/flows/avatar",
    "title": "Avatar",
    "section": "Get avatar ( GET )",
    "anchor": "get-avatar-get",
    "text": "Retrieve the image_url for a trainer profile. Endpoint: https://cdn.glofox.com/{ENVIRONMENT}/{NAMESPACE}/branches/{branchId}/users/{userId}/{userId}.png Method: GET Content-Type: application/json Where you have the following variables: Field Description ENVIRONMENT Specifies the environment context.…"
  },
  {
    "route": "/glofox/flows/avatar",
    "title": "Avatar",
    "section": "Upload an avatar ( POST )",
    "anchor": "upload-an-avatar-post",
    "text": "Upload a user's profile avatar. Endpoint: /assets/upload/users/{userId}/profile Method: POST Content-Type: application/json Required Headers { \"x-glofox-branch-id\" : \"{branch_id}\" , \"x-api-key\" : \"{api_key}\" , \"x-glofox-api-token\" : \"{api_token}\" } Request Body Form data : `Image=@ \"{local-path-to-i…"
  },
  {
    "route": "/glofox/flows/avatar",
    "title": "Avatar",
    "section": "How to deal with missing images and 403 responses",
    "anchor": "how-to-deal-with-missing-images-and-403-responses",
    "text": "The image_url field in trainer objects follows a fixed URL pattern, which means it may be present even when the user has not uploaded an image. If the referenced object does not exist in storage, attempting to fetch it results in an HTTP 403 Forbidden response rather than a 404 Not Found. As an inte…"
  },
  {
    "route": "/glofox/flows/book",
    "title": "Bookings workflow",
    "text": "Use the Bookings endpoints to manage bookings and classes. For more information about Classes, access the Classes section in the API Reference."
  },
  {
    "route": "/glofox/flows/book",
    "title": "Bookings workflow",
    "section": "List available classes ( POST )",
    "anchor": "list-available-classes-post",
    "text": "To retrieve the list of available classes, use the model and model_id fields from the response as follows: Endpoint: /2.0/bookings Method: POST Content-Type: application/json Required Headers { \"x-glofox-branch-id\" : \"{branch_id}\" , \"x-api-key\" : \"{api_key}\" , \"x-glofox-api-token\" : \"{api_token}\" }…"
  },
  {
    "route": "/glofox/flows/book",
    "title": "Bookings workflow",
    "section": "Get streaming link ( GET )",
    "anchor": "get-streaming-link-get",
    "text": "To obtain the streaming link for an online class, use the following endpoint: Endpoint: /2.0/events/{event_id}?include=facility,model,trainers,program&limit=100 Method: GET Content-Type: application/json Request Headers: Request Body: The response includes the external_provider_stream_url field."
  },
  {
    "route": "/glofox/flows/book",
    "title": "Bookings workflow",
    "section": "Get booking information for users ( GET )",
    "anchor": "get-booking-information-for-users-get",
    "text": "To retrieve a list of user bookings with detailed information, use: Endpoint: /2.0/bookings?branchId={{x-glofox-branch-id}}&user_id={{sample-user-id}}&include=\"facility,model,trainers\"&sort_by=\"-time_start&across_branches=true Method: GET Content-Type: application/json If the image_url field returns…"
  },
  {
    "route": "/glofox/flows/book",
    "title": "Bookings workflow",
    "section": "Waiting list",
    "anchor": "waiting-list",
    "text": "To join a waiting list, include the field join_waiting_list: true in the booking payload. If the user is already on the waiting list, if spots are available, or if the waiting list is full, the request fails. Waiting list promotion settings live in the Dashboard under the Booking tab. When a user ca…"
  },
  {
    "route": "/glofox/flows/book",
    "title": "Bookings workflow",
    "section": "Book a trainer ( POST )",
    "anchor": "book-a-trainer-post",
    "text": "Glofox deprecated the trainers model in favor of the appointments model. Verify your version before you implement this flow. To book a trainer, use the following request: Endpoint: /2.0/bookings Method: POST Content-Type: application/json Required Headers { \"x-glofox-branch-id\" : \"{branch_id}\" , \"x-…"
  },
  {
    "route": "/glofox/flows/book",
    "title": "Bookings workflow",
    "section": "Get booking price with credits ( GET )",
    "anchor": "get-booking-price-with-credits-get",
    "text": "To determine if a user has valid credits for a booking, use the following endpoints: Events: GET /2.0/branches/{branch_id}/events/{event_id}/price?for={user_id} timeslot: GET /2.0/branches/{branch_id}/appointments/{timeslot_id}/price?for={user_id} Courses: GET /2.0/branches/{branch_id}/courses/{even…"
  },
  {
    "route": "/glofox/flows/book",
    "title": "Bookings workflow",
    "section": "Get user credits ( GET )",
    "anchor": "get-user-credits-get",
    "text": "To retrieve a user’s credit packs and total available credits on the current page: Endpoint: /2.0/credits?user_id={user_id} Method: GET Content-Type: application/json The response is a paginated list ( object , page , limit , has_more , total_count , data ). Each credit pack is an object in data . U…"
  },
  {
    "route": "/glofox/flows/lead-sale",
    "title": "Lead capture and sale flow",
    "text": "This guide provides a comprehensive, step-by-step overview for onboarding members using the Glofox API."
  },
  {
    "route": "/glofox/flows/lead-sale",
    "title": "Lead capture and sale flow",
    "section": "POST : Register a member",
    "anchor": "post-register-a-member",
    "text": "To register a member with a specific location, use the endpoints detailed in the Users section of the API Reference. To create a new member within a particular studio, submit a request to the following endpoint: Endpoint: /2.0/register Method : POST Content-Type : application/json Required Headers {…"
  },
  {
    "route": "/glofox/flows/lead-sale",
    "title": "Lead capture and sale flow",
    "section": "Registration flag",
    "anchor": "registration-flag",
    "text": "To create a new member within a particular studio, turn on Registration from the apps and web integration in the Dashboard. Otherwise, the app shows the following error message: This branch does not allow pay as you go."
  },
  {
    "route": "/glofox/flows/lead-sale",
    "title": "Lead capture and sale flow",
    "section": "Date of birth",
    "anchor": "date-of-birth",
    "text": "When registering a new member, require the date of birth only when you enable Set minimum age a client needs to be to create an account in your Studio under Settings > Clients . When you turn off this option, the date of birth is optional. Important Add the minimum age value."
  },
  {
    "route": "/glofox/flows/lead-sale",
    "title": "Lead capture and sale flow",
    "section": "GET : Waiver template",
    "anchor": "get-waiver-template",
    "text": "To present the waiver agreement to a member, retrieve the template using the member-authenticated trigger. Endpoint: /2.3/branches/{branchId}/agreements/template/trigger/{trigger} Method: GET Content-Type: application/json"
  },
  {
    "route": "/glofox/flows/lead-sale",
    "title": "Lead capture and sale flow",
    "section": "Memberships",
    "anchor": "memberships",
    "text": "This section covers the onboarding flow with API calls and one sequencing constraint."
  },
  {
    "route": "/glofox/flows/lead-sale",
    "title": "Lead capture and sale flow",
    "section": "GET : Memberships",
    "anchor": "get-memberships",
    "text": "To browse and purchase memberships, use the memberships listing endpoint. Endpoint: /2.0/memberships Method: GET Content-Type: application/json Important For more information, access the Electronic Agreements section on the API Reference."
  },
  {
    "route": "/glofox/flows/lead-sale",
    "title": "Lead capture and sale flow",
    "section": "GET : Membership Terms & Conditions",
    "anchor": "get-membership-terms-andamp-conditions",
    "text": "You can obtain the membership terms and conditions from the same electronic agreements endpoint used for waivers. Endpoint: /2.3/branches/{branchId}/agreements/template/trigger/{trigger} Method: GET Content-Type: application/json"
  },
  {
    "route": "/glofox/flows/lead-sale",
    "title": "Lead capture and sale flow",
    "section": "Electronic Signature",
    "anchor": "electronic-signature",
    "text": "If you wish to enable electronic signature during onboarding, complete the membership purchase before you collect the signature. Typically, the signature prompt appears on the subsequent screen. For implementation guidance on this flow, contact the support team."
  },
  {
    "route": "/glofox/flows/lead-sale",
    "title": "Lead capture and sale flow",
    "section": "Add tax_id and address to a Member",
    "anchor": "add-tax-id-and-address-to-a-member",
    "text": "You can add a tax_id and address to a member during the lead capture process. Glofox stores this information in the metadata field of the member's profile."
  },
  {
    "route": "/glofox/flows/lead-sale",
    "title": "Lead capture and sale flow",
    "section": "Important",
    "anchor": "important",
    "text": "To enable the tax_id field for your branch, enable Capture Client's Tax ID on Settings > Tax in the Glofox Dashboard. If you turn off this feature, the tax_id field does not appear in the client's Details tab. Endpoint: /2.1/branches/{branchId}/leads Method: POST Content-Type: application/json The t…"
  },
  {
    "route": "/glofox/flows/login",
    "title": "Member login flow",
    "text": "Use the following workflow to resolve bundle‑scoped locations and perform credential verification."
  },
  {
    "route": "/glofox/flows/login",
    "title": "Member login flow",
    "section": "List locations ( GET )",
    "anchor": "list-locations-get",
    "text": "Retrieve a list of all branches (locations) associated with a specific bundle. Endpoint: /clients?bundle=<bundle> Method: GET Content-Type: application/json Base URL for location finder The base URL for this endpoint is app.glofox.com , which differs from the standard staging or production API URLs."
  },
  {
    "route": "/glofox/flows/login",
    "title": "Member login flow",
    "section": "Log in ( POST )",
    "anchor": "log-in-post",
    "text": "Use existing endpoints for end-user authentication. Use the response only to validate a username/password pair. All API requests require key and token header authentication. Do not use the JWT from the login endpoint for any subsequent API calls. Endpoint: /2.0/login Method: POST Content-Type: appli…"
  },
  {
    "route": "/glofox/flows/overdue-invoices",
    "title": "Overdue invoices and payment links",
    "text": "This guide covers how a member lists overdue subscription invoices and retrieves a payment link to collect payment. Use these endpoints together: list overdue invoices, then request a payment link for a specific invoice the member needs to pay."
  },
  {
    "route": "/glofox/flows/overdue-invoices",
    "title": "Overdue invoices and payment links",
    "section": "API flow overview",
    "anchor": "api-flow-overview",
    "text": "Step Method Endpoint API reference List overdue invoices GET /v3.0/users/{userID}/overdue-invoices List overdue invoices Get payment link POST /v3.0/payment-links/invoices/{invoiceID} Get payment link flowchart LR USR([Member]) subgraph gfapi[\"ABC GLOFOX API\"] direction LR S1([\"1. List overdue invoi…"
  },
  {
    "route": "/glofox/flows/overdue-invoices",
    "title": "Overdue invoices and payment links",
    "section": "List overdue invoices",
    "anchor": "list-overdue-invoices",
    "text": "Retrieve overdue subscription invoices for a user. Results are sorted by due date descending (newest first) and capped at 20 invoices. Endpoint: GET /v3.0/users/{userID}/overdue-invoices Headers: { \"Authorization\" : \"Bearer {member_jwt}\" } A successful request returns 200 OK : { \"data\" : [ { \"invoic…"
  },
  {
    "route": "/glofox/flows/overdue-invoices",
    "title": "Overdue invoices and payment links",
    "section": "Get payment link for an invoice",
    "anchor": "get-payment-link-for-an-invoice",
    "text": "Retrieve payment link details for a retriable invoice so the member can complete payment. Endpoint: POST /v3.0/payment-links/invoices/{invoiceID} Headers: { \"Authorization\" : \"Bearer {member_jwt}\" } A successful request returns 200 OK . When the invoice is retriable: { \"invoice_id\" : \"invoice-id\" ,…"
  },
  {
    "route": "/glofox/flows/payment-collector",
    "title": "Payment collector",
    "text": "This guide describes how to retrieve, manage, and tokenize user payment methods using the Glofox API. It outlines the steps for accessing stored credit cards, known as cards , and bank debit payment mandates, known as mandates , and payment history. It also explains how to initiate the payment colle…"
  },
  {
    "route": "/glofox/flows/payment-collector",
    "title": "Payment collector",
    "section": "Get credit card ( GET )",
    "anchor": "get-credit-card-get",
    "text": "Retrieve the credit card associated with a specific user. Endpoint: /2.1/branches/{{x-glofox-branch-id}}/users/{{sample-user-id}}/cards Method: GET Content-Type: application/json Required Headers { \"x-glofox-branch-id\" : \"{branch_id}\" , \"x-api-key\" : \"{api_key}\" , \"x-glofox-api-token\" : \"{api_token}…"
  },
  {
    "route": "/glofox/flows/payment-collector",
    "title": "Payment collector",
    "section": "Get debit mandate ( GET )",
    "anchor": "get-debit-mandate-get",
    "text": "Retrieve the bank debit mandates for a specific user ( mandates ). Endpoint: /2.1/branches/{{x-glofox-branch-id}}/users/{{sample-user-id}}/mandates Method: GET Content-Type: application/json Required Headers { \"x-glofox-branch-id\" : \"{branch_id}\" , \"x-api-key\" : \"{api_key}\" , \"x-glofox-api-token\" :…"
  },
  {
    "route": "/glofox/flows/payment-collector",
    "title": "Payment collector",
    "section": "Get payment history ( GET )",
    "anchor": "get-payment-history-get",
    "text": "Retrieve a user's payment history. Endpoint: /2.0/charges?user_id={{sample-user-id}}&page=1&sort_by=-created&include=model&across_branches=true&limit=100 Method: GET Content-Type: application/json Required Headers { \"x-glofox-branch-id\" : \"{branch_id}\" , \"x-api-key\" : \"{api_key}\" , \"x-glofox-api-tok…"
  },
  {
    "route": "/glofox/flows/payment-collector",
    "title": "Payment collector",
    "section": "Payment collector flow",
    "anchor": "payment-collector-flow",
    "text": "Implement the payment collector according to the workflow outlined in the following steps."
  },
  {
    "route": "/glofox/flows/payment-collector",
    "title": "Payment collector",
    "section": "Step 1",
    "anchor": "step-1",
    "text": "Invoke the payment collector endpoint to retrieve the payment collector iframe URL. The payment-methods endpoint returns this URL in its response. Endpoint: /2.1/branches/{branch_id}/payment-methods?includes=provider,iframe Method: GET Content-Type: application/json Required Headers { \"x-glofox-bran…"
  },
  {
    "route": "/glofox/flows/payment-collector",
    "title": "Payment collector",
    "section": "Step 2",
    "anchor": "step-2",
    "text": "Render an iframe using the URL obtained in the previous step. Construct the iframe URL by concatenating data[i].iframe.domain with data[i].iframe.full_path . Issuing a GET request to this constructed iframe URL loads the card collector interface, enabling users to enter card or mandate details. Upon…"
  },
  {
    "route": "/glofox/flows/payment-collector",
    "title": "Payment collector",
    "section": "Step 3",
    "anchor": "step-3",
    "text": "Monitor the completion of the tokenization process and retrieve the resulting token by using the postMessage API. Attach an onload handler to the payment collector iframe, send a registration message to register the parent window for tokenization callbacks, and then listen for message events to rece…"
  },
  {
    "route": "/glofox/flows/payment-collector",
    "title": "Payment collector",
    "section": "Step 4",
    "anchor": "step-4",
    "text": "Submit the token and options to the appropriate endpoint to save the new card or mandate. After you obtain the token and options, send them to the relevant endpoint in the Glofox API to register the new payment method. Cards endpoint Endpoint: /2.1/branches/{branch_id}/users/{user_id}/cards Method:…"
  },
  {
    "route": "/glofox/flows/payment-collector",
    "title": "Payment collector",
    "section": "Membership purchase after adding a card",
    "anchor": "membership-purchase-after-adding-a-card",
    "text": "After the user has completed the payment collector flow, added a card or mandate, and chosen a membership plan, complete the purchase with the membership purchase endpoint. That call charges the stored payment method for the selected plan. API Reference: Purchase membership plan Endpoint: POST /2.2/…"
  },
  {
    "route": "/glofox/flows/payment-collector",
    "title": "Payment collector",
    "section": "Membership price breakdown (cart)",
    "anchor": "membership-price-breakdown-cart",
    "text": "For a correct price breakdown before purchase, including taxes, fees, and totals, use the cart pre-checkout endpoint instead of relying only on catalog or UI display values. API Reference: Pre-checkout cart Endpoint: POST /v2.0/carts/pre-checkout"
  },
  {
    "route": "/glofox/flows/payment-collector",
    "title": "Payment collector",
    "section": "Purchasing products",
    "anchor": "purchasing-products",
    "text": "Product purchases use the cart APIs in a separate flow: list products, create a cart, then check out. See Purchase product for step-by-step details, API Reference links, cart ownership, and restrictions such as no mixed product-and-membership carts."
  },
  {
    "route": "/glofox/flows/payment-collector",
    "title": "Payment collector",
    "section": "Payment collector iframe",
    "anchor": "payment-collector-iframe",
    "text": "If you use the payment collector iframe, request domain authorization via email or Slack. The domain https://localhost is pre-authorized for local development."
  },
  {
    "route": "/glofox/flows/purchase-product",
    "title": "Product purchase flow",
    "text": "This guide describes how to purchase products through the Glofox API using a cart-based flow. When a user purchases a membership , they use a single RESTful endpoint, as described in Payment collector . Product purchases follow a structured multi-step flow: list products, create a cart, then check o…"
  },
  {
    "route": "/glofox/flows/purchase-product",
    "title": "Product purchase flow",
    "section": "API flow overview",
    "anchor": "api-flow-overview",
    "text": "The flow uses standard HTTP methods and resource-based URLs. It consists of three sequential steps , each with its own endpoint: Get products —Retrieve available products for a specific location. Create cart —Initialize a cart with selected products and payment method; the response includes a price…"
  },
  {
    "route": "/glofox/flows/purchase-product",
    "title": "Product purchase flow",
    "section": "API flow details",
    "anchor": "api-flow-details",
    "text": "Step Method Endpoint API Reference Get products GET /v3.0/locations/{location_id}/products Get products Create cart POST /v3.0/carts Create cart Checkout cart POST /v3.0/carts/{cart_id}/checkout Checkout cart The diagram below illustrates the sequential steps in the product purchase flow. flowchart…"
  },
  {
    "route": "/glofox/flows/purchase-product",
    "title": "Product purchase flow",
    "section": "Cart ownership and checkout authorization",
    "anchor": "cart-ownership-and-checkout-authorization",
    "text": "A cart is always tied to the authenticated user who created it . Only that user can check out that cart. Authentication for these calls uses the x-glofox-impersonated-member-id request header to identify the member the operation is for. That prevents one user from checking out another user’s cart. G…"
  },
  {
    "route": "/glofox/flows/purchase-product",
    "title": "Product purchase flow",
    "section": "Restrictions",
    "anchor": "restrictions",
    "text": "No mixed purchases: You can't combine product and membership in a single cart transaction. For example, buying a product and a membership together isn't supported. Consistent payment processing: These cart endpoints use the same payment processing stack as the existing purchase flows elsewhere in th…"
  },
  {
    "route": "/glofox/flows/purchase-product",
    "title": "Product purchase flow",
    "section": "Final notes",
    "anchor": "final-notes",
    "text": "Follow the cart-based sequence and the authentication rules so that checkout stays consistent and secure. For request and response shapes, use the OpenAPI specification in the API Reference section of this portal, or contact Glofox API support if you need help."
  },
  {
    "route": "/glofox/flows/push-notifications",
    "title": "Push notifications",
    "text": "This guide covers how to register a device for push notifications and how to consume the resulting webhook event."
  },
  {
    "route": "/glofox/flows/push-notifications",
    "title": "Push notifications",
    "section": "Register a device",
    "anchor": "register-a-device",
    "text": "Use the Register device endpoint to register a mobile device that should receive push notifications. Endpoint: POST /v3.0/push-notifications/devices Method: POST Content-Type: application/json Headers: { \"x-glofox-branch-id\" : \"{branch_id}\" , \"x-api-key\" : \"{api_key}\" , \"x-glofox-api-token\" : \"{api_…"
  },
  {
    "route": "/glofox/flows/push-notifications",
    "title": "Push notifications",
    "section": "Receive push notification webhook events",
    "anchor": "receive-push-notification-webhook-events",
    "text": "When Glofox creates a push notification, it dispatches a webhook event with event type PUSH_NOTIFICATION_CREATED . Webhook event example: { \"Type\" : \"PUSH_NOTIFICATION_CREATED\" , \"Metadata\" : { \"trace_id\" : \"string\" , \"location_id\" : \"location-id\" , \"version\" : \"string\" } , \"Timestamp\" : \"2026-03-18…"
  },
  {
    "route": "/glofox/flows/push-notifications",
    "title": "Push notifications",
    "section": "Get notifications for a user",
    "anchor": "get-notifications-for-a-user",
    "text": "Retrieve the notification history for a specific user at a given location. Endpoint: GET /v3.0/members/{user_id}/push-notifications Params page — Page index, 1-based (default: 1) limit — Page size (default: 20, min: 1, max: 100) Method: GET Content-Type: application/json Headers: { \"x-glofox-branch-…"
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "text": "Use this how-to the first time you open the ABC Fitness Developer Portal. Use it if you are new to the Glofox API or if you previously used the previous developer docs site. If you already have an account, skip to Request API access ."
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "section": "Prerequisites",
    "anchor": "prerequisites",
    "text": "A work email address Your business or studio name, Branch IDs or namespace (if you know them), and a short description of your integration use case If you only need to read documentation, you can skip account creation. You must log in to use Request access ."
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "section": "API overview",
    "anchor": "api-overview",
    "text": "Glofox's API uses the REST protocol. The API enables external applications to access, create, and edit users, memberships, credits, classes, bookings & payments. Each endpoint returns JSON responses. Include these headers in every API call: x-glofox-branch-id x-api-key x-glofox-api-token"
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "section": "Open the portal",
    "anchor": "open-the-portal",
    "text": "Go to https://api-portal.glofox.com/api-portal/#/ . Bookmark this URL. If you still have bookmarks to the previous developer docs site, replace them with the portal URL in the preceding step."
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "section": "Create an account or log in",
    "anchor": "create-an-account-or-log-in",
    "text": "Create an account or log in"
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "section": "If you do not have a portal account yet",
    "anchor": "if-you-do-not-have-a-portal-account-yet",
    "text": "Select Sign up . Enter your email address and password, and accept the API Terms of Use and Privacy Policy. Complete sign-up, then log in ."
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "section": "If you already have an account",
    "anchor": "if-you-already-have-an-account",
    "text": "Select Log in . Enter your email address and password."
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "section": "If you forgot your password",
    "anchor": "if-you-forgot-your-password",
    "text": "On the log-in page, select Forgot password? Follow the email instructions, then log in with your new password."
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "section": "Explore the documentation",
    "anchor": "explore-the-documentation",
    "text": "Open the portal. You land on this Get started page. Use the sidebar for guides ( Authentication , Common concepts , Webhooks , and Flows). Use the API Reference when you need the interactive OpenAPI reference (including error handling). New to the API? Continue with Authentication , skim Common conc…"
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "section": "Request API access",
    "anchor": "request-api-access",
    "text": "You need an API key and API token ( x-api-key and x-glofox-api-token ) for backend integrations. Request them from the portal. Do not send the old email template to apiactivation@abcfitness.com for new requests. Make sure you are logged in. In the top navigation, select Request access . Choose reque…"
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "section": "Important notes",
    "anchor": "important-notes",
    "text": "Use the API key and token only for backend integrations, not in browsers. If you need to use this API key, proxy requests through your backend so it makes the authenticated call to the API Gateway and keeps the key and token private. Regarding timestamps, most of the API uses UTC. When a field uses…"
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "section": "Request webhook access",
    "anchor": "request-webhook-access",
    "text": "Webhook access is not granted through the Request access form. To enable webhooks for your integration: Read the Webhooks guide for timeouts, retries, and signature validation. Review available webhook payloads in the API Reference . Contact apiactivation@abcfitness.com to request webhook configurat…"
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "section": "Webhooks request email template",
    "anchor": "webhooks-request-email-template",
    "text": "When you request webhook access, include the following information: Subject: Webhooks Setup Request Business / Studio name: Contact name & email: Branch ID(s) / Namespace (if known): Environments required (Production / Staging + Production): Target start date: Webhook event domains and their callbac…"
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "section": "Coming from the old docs site?",
    "anchor": "coming-from-the-old-docs-site",
    "text": "You used to… Do this instead Send an access-request template by email Sign up / Log in , then use Request access Browse Overview and Flows Open the portal → sidebar docs and Flows Open the old OpenAPI UI Use the API Reference in the portal"
  },
  {
    "route": "/glofox",
    "title": "Get started",
    "section": "If something goes wrong",
    "anchor": "if-something-goes-wrong",
    "text": "Cannot log in: Use Forgot password? or confirm you signed up on this portal (accounts from other ABC systems do not apply here). Request access is missing: Log in first; the link is shown for authenticated users. Need help with API behavior: Contact glofox.apisupport@abcfitness.com ."
  }
];
